import MultilineTextEditor from "../../../components/common/editors/MultilineTextEditor";
import NotesEditor from "../../../components/common/editors/NotesEditor";
import { SingleImageUrlEditor } from "../../../components/common/images/SingleImageUrlEditor";
import MongoDocEditor from "../../../components/lego/MongoDocEditor";
import SpecsGroupCompactInput from "../spec-schema-editor/SpecsGroupCompactInput";
import FactoidImageCameraSelector from "./FactoidImageCameraSelector";
import FragmentSourceEditor from "./FragmentSourceEditor";
import FragmentTypeEditor from "./FragmentsTypeEditor";
import SpecSourcesList from "./SpecSourcesList";

export default function FragmentEditor({ value, onSave, onCancel, ...otherProps }) {
    const extendSchema = {
        type: (value, onChange) => <FragmentTypeEditor value={value} onChange={onChange} showAll={false} />,
        text: (value, onChange, obj) => <div>
            <MultilineTextEditor value={value} onChange={onChange} minRows={3} />
            {obj.type === 'image' ? <SingleImageUrlEditor 
                s3ImageService="services/s3-images-cerokm" 
                sourceType="cerokm-admin-uploaded"
                category="spec-manual-upload" 
                folder="spec-manual-upload"
                value={value ? {url: value} : null} 
                onChange={obj => onChange(obj?.url || '')} 
            /> : null}
        </div>,
        specsGroupIds: (value, onChange) => <SpecsGroupCompactInput value={value} onChange={onChange} />,
        sourceIds: (value, onChange) => <SpecSourcesList sourceIds={value} />,
        sourceType: (value, onChange) => <FragmentSourceEditor value={value} onChange={onChange} />,
        notes: (value, onChange) => <NotesEditor value={value} onChange={onChange} />,
        camera: (value, onChange) => <FactoidImageCameraSelector value={value} onChange={onChange} />,
    }

    return <MongoDocEditor hideState={true} extendSchema={extendSchema} obj={value} onSave={onSave} onCancel={onCancel} {...otherProps} />;
}